import { deepForEach, deepFind } from "#/utils/deep-object-and-array";
import { getProperty, hasProperty } from "dot-prop";

function deepHasAnyKey(value, keyPaths) {
  let foundKeyPath = null;
  let foundObject = deepFind(value, ({ subject }) => {
    foundKeyPath = keyPaths.find((path) => hasProperty(subject, path));

    if (foundKeyPath) return true;
  })?.subject;

  return (
    foundKeyPath && {
      object: foundObject,
      keyPath: foundKeyPath,
      value: getProperty(foundObject, foundKeyPath),
    }
  );
}

export { deepForEach, deepFind, deepHasAnyKey };